import React, { Component } from 'react';
import ContextMenuButton from './ContextMenuButton';
class NavBarSettings extends Component {
    shouldComponentUpdate(nextProps) {
        return (this.props.template.settingsSections !== nextProps.template.settingsSections ||
            this.props.windowWidth !== nextProps.windowWidth);
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const { template } = this.props;
        if (!template.settingsSections || template.settingsSections.length <= 0) {
            return null;
        }
        const options = [].concat(
        // @ts-ignore
        ...(template.settingsSections || []).map((section) => section.items));
        options.map((option) => {
            option.link = option.primaryLink;
            return option;
        });
        const name = (_c = (_b = (_a = template) === null || _a === void 0 ? void 0 : _a.settingsSections) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.header;
        const tier = (_f = (_e = (_d = template) === null || _d === void 0 ? void 0 : _d.settingsSections) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.label;
        const showSignInButton = (_j = (_h = (_g = template) === null || _g === void 0 ? void 0 : _g.settingsSections) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.showSignInButton;
        const signInButtonText = template.signInButtonText;
        return React.createElement(ContextMenuButton, { id: 'accountSetting', options: options, variant: 'glass', isRefinement: false, size: "small", iconName: "profile", header: name, label: tier, showSignInButton: showSignInButton, signInButtonText: signInButtonText, ariaLabelText: "Account Setting Menu" });
    }
}
export default NavBarSettings;
